<h4>{{title}}</h4>
<mat-accordion multi>
  <div *ngFor="let item of field.fieldGroup; let i = index;" class="repeat-group">
    <mat-expansion-panel class="panel">
      <mat-expansion-panel-header>
        <mat-panel-title fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10">
          <div>{{item?.model?.name}}</div>

          <button mat-icon-button color="warn" (click)="remove(i)" aria-label="delete">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <formly-group [field]="item" [form]="formControl" [options]="options"> </formly-group>
    </mat-expansion-panel>
  </div>
  <div>
    <button mat-button color="green" type="button" (click)="add()">
      <mat-icon>add</mat-icon>{{btnText}}
    </button>
  </div>
</mat-accordion>
